import { Descriptor } from "hybrids";
import { Socket } from "socket.io-client";

// @ts-ignore
import io from "socket.io-client/dist/socket.io.js";

interface SocketEl {
  socketUrl: string;
  accessToken: string;
}

export default function socketio<E extends SocketEl>(
  fn: (host: E, socket: Socket) => void
): Descriptor<E, Socket | null> {
  return {
    get: (host, lastValue) => {
      if (lastValue) lastValue.disconnect();

      const { socketUrl, accessToken } = host;

      if (socketUrl && accessToken) {
        const socket: Socket = io(host.socketUrl, {
          rejectUnauthorized: false,
          auth: { accessToken: host.accessToken },
        });

        fn(host, socket);

        return socket;
      }

      return null;
    },
    connect: (host, key) => {
      return () => {
        host[key]?.disconnect();
      };
    },
    observe() {},
  };
}
